import React, { useState } from "react";
import "./file-tree.css";

function TreeNode({ file, setActiveFile, activeFile, onClickRow }) {
	const [collapsed, setCollapsed] = useState(file.collapsed === false ? false : true);
	const liClassName = file.hasChildren ? "parent-node" : "child-node";

	const toggleCollapse = (e) => {
		file.collapsed = !collapsed;
		setCollapsed(file.collapsed);
		if (!collapsed) {
			setActiveFile(file.hash);
			//onClickRow(file); 
		}
		else {
			e.stopPropagation();
		}
	};

	const handleClick = () => {
		setActiveFile(file.hash);
		onClickRow(file);
	};

	return (
		<>
			<li className={classNames(liClassName, activeFile === file.hash ? " active" : null)}>
				<div onClick={handleClick}>
					{file.hasChildren == true && (
						<em
							onClick={toggleCollapse}
							className={`expand la la-angle-${collapsed ? "right" : "down"}`}
						></em>
					)}
					<div className="li-text-content">
						<em className="fa fa-folder">
							{file.isShared ? <em className="la la-user-friends shared" /> : null}
						</em>
						<span>{file.name}</span>
					</div>
				</div>
				{file.hasChildren == true && !collapsed && (
					<ul className="child-parent-container">
						{file.children?.filter((item) => item.isFolder)
							.map((childFile, i) => (
								<TreeNode
									key={i}
									file={childFile}
									setActiveFile={setActiveFile}
									activeFile={activeFile}
									onClickRow={onClickRow}
								/>
							))}
					</ul>
				)}
			</li>

		</>
	);
}

function FileTree({ files, onSelectedRow, customClassName }) {
	const [activeFile, setActiveFile] = useState(sessionStorage.getItem('fm_path') || 'l1_LzAv');
	return (
		<div className={`file-manager__body-tree ${customClassName || ''}`}>
			<ul className="parent-container">
				{files
					//.filter((item) => item.isFolder)
					.map((file, i) => (
						<TreeNode
							key={i}
							file={file}
							setActiveFile={setActiveFile}
							activeFile={activeFile}
							onClickRow={onSelectedRow}
						/>
					))}
			</ul>
		</div>
	);
}

export default FileTree;
